import React from 'react'
import Header from '../../../../components/Business/Thanks/foodslabo/Header'
import ThankYouContent from '../../../../components/Business/Thanks/foodslabo/ThankYouContent'
import Footer from '../../../../components/Business/Thanks/foodslabo/Footer'

export default function FoodslaboThanks() {
    return (
        <>
            <Header />
            <ThankYouContent />
            <Footer />
        </>
    )
}
